<template>
    <div>
        <div class="logo">
            <img :src="partners.topLogo" class="logoimg" />
        </div>
        <div class="contentImg">
            <div class="title">博览参观登记</div>
            <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/outSiteDate/img/appointCode.png" class="codeimg" alt="">
            <div class="content">
                请访问LTE2023注册链接
            </div>
            <div class="content">
                <span class="url" @click="copyUrl()" id="copyUrl" data-clipboard-text="https://lte2023.jemexonline.com/">https://lte2023.jemexonline.com/</span>
                或
            </div>
            <div class="content"  style="margin-bottom:30px;">
                <p>将此页面截图保存到相册，</p>
                <p>点开微信扫一扫，立即进行登记。</p>
            </div>
          
            <div class="content">   
                登记完成后系统将会通过电邮发送确认信和入场二维码。
            </div>
            <div class="content"  style="margin-bottom:30px;">
                <p>你也会收到登记户口资讯，让你登入你的户口管理个人资料，</p>
                <p>并于九月下旬起预留博览节目座位。</p>
            </div>
        </div>
        
        <div class="bottomImg">
            <img :src="partners.bottomImg" style="width: 100%;" />
        </div>
    </div>
</template>

<script>
import { GetQueryString } from '@/utils/utils'
import Clipboard from 'clipboard'
export default {
    data() {
        return{
            partners: '',
            contentImg:''
        }
    },
    methods: {
        copyUrl() {
            var _this = this
            var clipboard = new Clipboard('#copyUrl')
            console.log(clipboard)
            clipboard.on('success', (e) => {
                _this.$toast.success('已成功复制到粘贴板')
                //  释放内存
                clipboard.destroy()
            })

            clipboard.on('error', (e) => {
                console.log(e)
                // 不支持复制
                _this.$toast.fail('该浏览器不支持复制')
                // 释放内存
                clipboard.destroy()
            })
        },
    },
    mounted() {
        let jsonName = GetQueryString('name') || 'ltexpo-partner'
        if (jsonName) {
            let dataUrl = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/outSiteDate/' + jsonName + '.json' + '?v=' + new Date();
            this.$http({
                method: 'get',
                url: dataUrl
            }).then((res) => {
                this.partners = res
            })
        }
    }
}

</script>
<style lang="less" scoped>
.logo {
    padding: 20px;
    position: fixed;
    background: #fff;
    z-index: 99990;
    width: 100%;

    .logoimg {
        height: 100px;
        width: 350px;
        object-fit: contain;
    }
}
.title{
   color: #00b050; 
   font-size: 30px;
   text-align: center;
   font-weight: 600;
}
.codeimg{
    margin: 30px auto;
    width: 300px;
    height: 300px;
}
.content{
    font-size: 14px;
    padding: 0 0px;
    .url{
        color: #0563c1;
    }
}
.contentImg {
    padding-top: 160px;
    // padding-bottom: 30px;
    width: 100%;
    font-size: 0;
}
</style>